<!--begin::Sidebar-->
<div id="sidebar" class="app-sidebar flex-column overflow-auto" [ngClass]="{'drawer drawer-start': isMobileDrawer}"
  bwsClickOutside (clickOutside)="hideSidebar()" [excludeBeforeClick]="true" [exclude]="'#sidebar-toggler'">

  <!--begin::Logo-->
  <div class="d-flex justify-content-center mt-10">
    <ng-content select="[logo]"></ng-content>
  </div>

  <!--begin::Navs-->
  <div class="app-sidebar-navs flex-column-fluid py-6">
    <div class="hover-scroll-y my-2">

      <div class="menu menu-rounded menu-column">
        <div class="menu-item">
          <div class="menu-content menu-heading text-uppercase fs-7">
            Navigation
          </div>
        </div>
        @for (link of navLinks; track link) {
          @if (link.separator) {
            <div class="separator border-gray-700"></div>
          }
          @if (!link.separator) {
            <div class="menu-item"
              [class.menu-accordion]="link.children?.length" [class.show]="!!link.isCollapsed">
              <!-- Children -->
              @if (link.children?.length) {
                <span class="menu-link" (click)="link.isCollapsed = !link.isCollapsed">
                  @if (link.icon) {
                    <span class="menu-icon"><bws-mdi [name]="link.icon"/></span>
                  }
                  @if (!link.icon) {
                    <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                  }
                  <span class="menu-title">{{link.title!|translate}}</span>
                  <span class="menu-arrow"></span>
                </span>
                <div class="menu-sub menu-sub-accordion show" style="" [collapse]="!!link.isCollapsed" [isAnimated]="true">
                  @for (child of link.children; track child) {
                    <div class="menu-item ms-5">
                      <a [routerLink]="child.route! | localize" routerLinkActive="active" class="menu-link">
                        @if (child.icon) {
                          <span class="menu-icon"><bws-mdi [name]="child.icon"/></span>
                        }
                        @if (!child.icon) {
                          <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                        }
                        <span class="menu-title">{{child.title!|translate}}</span>
                      </a>
                    </div>
                  }
                </div>
              }
              <!-- No child -->
              @if (!link.children?.length) {
                <a [routerLink]="link.route! | localize" routerLinkActive="active" class="menu-link">
                  @if (link.icon) {
                    <span class="menu-icon"><bws-mdi [name]="link.icon"/></span>
                  }
                  @if (!link.icon) {
                    <span class="menu-bullet"><span class="bullet bullet-dot"></span></span>
                  }
                  <span class="menu-title">{{link.title!|translate}}</span>
                </a>
              }
            </div>
          }
        }
      </div>

    </div>
  </div>
  <!--end::Navs-->


  <!--begin::Footer-->
  <div class="app-sidebar-footer d-flex flex-stack px-11 pb-10" id="kt_app_sidebar_footer">

    <!-- Language change -->
    <div class="btn-group" dropdown [dropup]="true">
      <button id="button-basic" dropdownToggle type="button" class="btn btn-secondary btn-sm fs-8 dropdown-toggle"
        aria-controls="dropdown-basic">
        @if (languageMeta[localizeRouterService.parser.currentLang]; as meta) {
          <img [src]="meta.flag" [alt]="meta.label" class="w-15px h-15px rounded-1 me-2"> {{meta.label}}
        } @else {
          {{localizeRouterService.parser.currentLang}}
        }
      </button>
      <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu"
        role="menu" aria-labelledby="button-basic">
        @for (locale of locales; track locale) {
          <li role="menuitem">
            <span class="dropdown-item py-1 cursor-pointer" (click)="changeLanguage(locale)">
              @if (languageMeta[locale]; as meta) {
                <img [src]="meta.flag" [alt]="meta.label" class="w-15px h-15px rounded-1 me-2"> {{meta.label}}
              } @else {
                {{locale}}
              }
            </span>
          </li>
        }
      </ul>
    </div>

  </div>
</div>
<!--end::Sidebar-->
